import { Typography } from "@circle-react-uikit/Typography";
import type { ReactNode } from "react";

import { StatusIcon } from "./StatusIcon";

type Variant = "loading" | "success" | "error";

interface BigLoaderProps {
  animate?: boolean;
  icon?: ReactNode;
  subtitle?: ReactNode;
  title?: ReactNode;
  variant?: Variant;
}

export const BigLoader = ({
  animate = true,
  icon,
  title,
  subtitle,
  variant = "loading",
}: BigLoaderProps) => (
  <div className="bg-primary flex size-full flex-col items-center justify-center">
    <div className="flex size-full max-w-xl flex-col items-center justify-center gap-4">
      <div className="pb-5">
        <StatusIcon variant={variant} icon={icon} animate={animate} />
      </div>
      {title && (
        <div className="text-center">
          <Typography.TitleMd>{title}</Typography.TitleMd>
        </div>
      )}
      {subtitle && (
        <div className="text-center">
          <Typography.LabelMd color="text-default">
            {subtitle}
          </Typography.LabelMd>
        </div>
      )}
    </div>
  </div>
);
